/**
 * Junto Frontend Tab Component
 * 
 * This is the base tab component that all Junto frontend systems use.
 * It maintains exact visual equivalence to the current Sol Room tab styles
 * while being configurable for other studios.
 */

import React from 'react';
import styled from 'styled-components';
import { solRoomTheme } from '../../themes/sol-room.js';

const TabContainer = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme?.spacing?.lg || solRoomTheme.spacing.lg};
  border-bottom: 1px solid ${props => props.theme?.colors?.neutral?.light || solRoomTheme.colors.neutral.light};
  overflow: visible;
`;

const TabButton = styled.button`
  flex: 1;
  padding: ${props => props.theme?.spacing?.md || solRoomTheme.spacing.md};
  background: none;
  border: none;
  font-family: ${props => props.theme?.typography?.secondary?.fontFamily || solRoomTheme.typography.secondary.fontFamily};
  font-size: 1rem;
  font-weight: 500;
  color: ${props => 
    props.$active 
      ? props.theme?.colors?.accent?.main || solRoomTheme.colors.accent.main
      : props.theme?.colors?.primary?.text || solRoomTheme.colors.primary.text
  };
  cursor: pointer;
  border-bottom: 2px solid ${props => 
    props.$active 
      ? props.theme?.colors?.accent?.main || solRoomTheme.colors.accent.main
      : 'transparent'
  };
  transition: ${props => props.theme?.transitions?.default || solRoomTheme.transitions.default};
  opacity: ${props => props.$active ? 1 : 0.7};
  
  &:hover {
    opacity: 1;
    color: ${props => props.theme?.colors?.accent?.main || solRoomTheme.colors.accent.main};
  }
  
  @media (max-width: ${props => props.theme?.breakpoints?.tablet || solRoomTheme.breakpoints.tablet}) {
    padding: ${props => props.theme?.spacing?.sm || solRoomTheme.spacing.sm} ${props => props.theme?.spacing?.md || solRoomTheme.spacing.md};
    font-size: 0.9rem;
  }
`;

const TabContent = styled.div`
  /* Content styling handled by parent components */
`;

export const TabGroup = ({ children, theme }) => (
  <TabContainer theme={theme}>
    {children}
  </TabContainer>
);

export const Tab = ({ active, onClick, children, theme, ...props }) => (
  <TabButton 
    $active={active} 
    onClick={onClick}
    theme={theme}
    type="button"
    {...props}
  >
    {children}
  </TabButton>
);

export const TabPanel = ({ children, theme }) => (
  <TabContent theme={theme}>
    {children}
  </TabContent>
);

const TabComponents = { TabGroup, Tab, TabPanel };
export default TabComponents;